import React, { FunctionComponent, PropsWithChildren } from 'react'
import { useCheckoutState } from '../../state'
import { CheckoutStatus } from '../../model'

type StatusCondition = (status: CheckoutStatus) => boolean

interface CheckoutStatusGuardProps extends PropsWithChildren {
  condition: StatusCondition
}

export const CheckoutStatusGuard: FunctionComponent<CheckoutStatusGuardProps> = ({ condition, children }) => {
  const { status } = useCheckoutState()

  if (!condition(status)) {
    return null
  }

  return <>{children}</>
}

// Pre-configured guards for common use cases
export const NoErrorStatusGuard: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <CheckoutStatusGuard condition={(status) => status !== CheckoutStatus.Error}>{children}</CheckoutStatusGuard>
)

export const StartedStatusGuard: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <CheckoutStatusGuard condition={(status) => status >= CheckoutStatus.Started}>{children}</CheckoutStatusGuard>
)
